import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/ST.mp4";
import videoSource1 from "../../assets/videos/ST_Demo.mp4";
import architecture from "../../assets/images/resource/Speech_Text.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/azure-ai.png";
import st from "./../../assets/images/icons/st.png";
import msa from "./../../assets/images/icons/msa.png";

const SpeechToText = () => {
  pageTitle("Speech To Text");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper">
        <img src={SorBanner} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          {/* Centered text */}
          <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          />
          <div className="ai-overlay-center-text">
            <h2>
              Azure AI Customer <br />
              Call Processing
            </h2>
            <p>
              <img src={st} alt="Microsoft azure" style={{ height: "30px" }} />{" "}
              Speech To Text
            </p>
          </div>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            {/* <span class="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div class="siw-rpa-text">
              <p>
                Turn uploaded audio into structured insights with an automated
                Microsoft Azure workflow.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution converts recorded conversations into meaningful
                business insights through a streamlined AI-driven speech
                analytics workflow:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Four-Step Workflow
              </p>
              <ol>
                <li>
                  Upload – Recorded conversations are securely captured in the
                  cloud.
                </li>
                <li>
                  Transcribe – Speech is transformed into searchable digital
                  text.
                </li>
                <li>
                  Enrich – AI detects sentiment, key discussion themes, and
                  concise summaries.
                </li>
                <li>
                  Visualize – Insights are presented through dashboards and
                  management tools.
                </li>
              </ol>
            </div>
          </div>

          <div class="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated Azure AI Services.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>Azure AI Customer Call Processing</strong>
              ,
              <br />
              Click 👉{" "}
              <a
                href="https://ai.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Azure AI Speech To Text
              </a>
              .
            </p>
            <a href="/contact" class="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This architectural diagram illustrates an automated workflow for
            processing customer service calls by converting raw audio into
            actionable data. The journey begins when recorded conversations are
            uploaded to cloud storage, where they undergo intelligent
            transcription to transform spoken words into digital text. This text
            is then refined through AI-driven enrichment, utilizing advanced
            language models to identify sentiment, key themes, and concise
            summaries. Finally, these processed findings are funneled into
            visualization and management tools, allowing businesses to monitor
            performance and customer satisfaction in near real-time.
          </p>
          <img
            src={architecture}
            alt="Computer Vision"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing AI Customer Call Processing
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the{" "}
            <strong>Azure AI Customer Call Processing</strong>, Click 👉{" "}
            <a
              href="https://ai.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Azure AI Speech To Text
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default SpeechToText;
